import { Button, ConfigProvider, Modal } from "antd";
import React from "react";

export default function ConfirmModal({
  isModalOpen,
  records = {
    title: "Confirm please",
    message: "",
    handleOk: () => {},
    handleCancel: () => {},
    isClosable: true,
    confirmText: "Ok",
    cancelconfirmText: "Cancel",
    customStyle: {},
  },
  extraContent,
  showCancel = true,
}) {
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultHoverBorderColor: "#FFD700",
            defaultHoverColor: "#000000",
            fontFamily: "ubold",
          },
          Modal: {
            titleColor: "#572D86",
            titleFontSize: 24,
          },
        },
      }}
    >
      <Modal
        maskClosable={false}
        title={<div className="pt-1">{records.title}</div>}
        open={isModalOpen}
        onOk={records.handleOk}
        onCancel={records.handleCancel}
        closable={records.isClosable}
        okText={records.confirmText}
        cancelText={records.cancelconfirmText}
        style={records.customStyle}
        footer={
          showCancel
            ? [
                <Button key="cancel" onClick={records.handleCancel}>
                  {records.cancelconfirmText}
                </Button>,
                <Button
                  key="ok"
                  type="primary"
                  style={{
                    backgroundColor: "#FCBD10",
                    color: "#000000",
                    fontWeight: "bold",
                  }}
                  onClick={records.handleOk}
                >
                  {records.confirmText}
                </Button>,
              ]
            : [
                <Button
                  key="ok"
                  type="primary"
                  style={{
                    backgroundColor: "#FCBD10",
                    color: "#000000",
                    fontWeight: "bold",
                  }}
                  onClick={records.handleOk}
                >
                  {records.confirmText}
                </Button>,
              ]
        }
      >
        <div className="text-[16px] py-2">{records.message}</div>
        {extraContent ?? ""}
      </Modal>
    </ConfigProvider>
  );
}
